import { useMemo } from 'react';

import useMedias from '@Hooks/useMedias';
import useTranslation from '@Queries/useTranslation';
import Link from '@Navigation/Link';
import Img from '@UI/Img';
import CardInView from '@Components/CardInView';
import desktopImage from './images/desktopImage1.jpg';
import mobileImage from './images/mobileImage1.jpg';
import styles from './MainBanner.module.css';

import type { FC } from 'react';

const MainBanner: FC = () => {
  const { isMobile } = useMedias();
  const { t } = useTranslation();

  const banner = { id: 'main-banner', link: '/site/showroom' };
  const text = useMemo(
    () => ({
      title: t('main-banner.title'),
      showroom: t('main-banner.showroom'),
      address: t('main-banner.address'),
      phone: t('main-banner.phone'),
    }),
    [t],
  );

  return (
    <div className={styles.wrapper}>
      <CardInView
        listTitle='main-slider'
        position={0}
        card={banner}
        cardType='promo'
        isSingleCard
        id={banner.id}
        targetPathname={banner.link}
        data-testid={`main-banner-slide1`}
      >
        <Link className={styles.banner} to={banner.link}>
          <Img
            className={styles.image}
            src={isMobile ? mobileImage : desktopImage}
            loading='eager'
          />

          {/* <div className={styles.content}>
            <Text className={styles.title} desktop={text.title} />
            <Text className={styles.showroom} desktop={text.showroom} />
            <Text className={styles.address} desktop={text.address} />
            <Text className={styles.phone} desktop={text.phone} />
          </div> */}
        </Link>
      </CardInView>
    </div>
  );
};

export default MainBanner;
